module.exports = __webpack_public_path__ + "static/img/headportrait.0a37da3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/headportrait.png
// module id = 5g7i
// module chunks = 1